import React, { useState } from "react";


const RCE = () => {
  const [activeTab, setActiveTab] = useState("about");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="college-details-container">
      {/* Page Title */}
      <header className="college-header">
        <h1 className="college-title">Rama College Of Education</h1>
        <p className="college-subtitle">
          Recognized by NCTE & Affiliated by K.U.K (Kurukshetra University)
        </p>
      </header>

      {/* Tabs Navigation */}
      <div className="college-tabs">
        <button
          className={`college-tab-button ${activeTab === "about" ? "active" : ""}`}
          onClick={() => handleTabClick("about")}
        >
          About the Program
        </button>
        <button
          className={`college-tab-button ${activeTab === "admission" ? "active" : ""}`}
          onClick={() => handleTabClick("admission")}
        >
          Admission Details
        </button>
        <button
          className={`college-tab-button ${activeTab === "photos" ? "active" : ""}`}
          onClick={() => handleTabClick("photos")}
        >
          Gallery
        </button>
      </div>

      {/* Tab Content */}
      <div className="college-tab-content">
        {activeTab === "about" && (
          <div className="college-tab-panel">
            <Section
              title="B.ED:"
              content="The Bachelor of Education (B.Ed.) Programme is a professional programme meant for preparing teachers"
            />
            <Section
              title="Duration:"
              content="The B.Ed. Programme shall be of duration of two academic years or of two semesters. However the students shall be permitted to complete the programme requirements within a maximum of three years from the date of admission to the programme"
            />
            <Section
              title="Working Days:"
              content="At least 200 working days per year are required, excluding admission and examination periods. The institution shall work for at least 36 hours per week."
            />
          </div>
        )}

        {activeTab === "admission" && (
          <div className="college-tab-panel">
            <Section
              title="Eligibility:"
              content="Bachelor’s degree in any discipline with 50% marks and participation in inter-college/inter-zonal/district/school competitions in sports and games recognized by AIU/IOA/SGFI/Govt. of India."
            />
            <Section
              title="Admission Procedure:"
              content="Admissions are merit-based, considering marks in entrance exams and qualifying examinations. Selection processes may vary as per university/state policies."
            />
            <Section
              title="Fee:"
              content="Fees are prescribed by the affiliating body/state government and follow NCTE guidelines. Capitation fees or donations are not permitted."
            />
          </div>
        )}

        {activeTab === "photos" && (
          <div className="college-gallery">
            <img src="ybed-thumb.jpg" alt="College Image 1" className="college-gallery-image" />
            <img src="rce2.jpg" alt="College Image 2" className="college-gallery-image" />
          </div>
        )}
      </div>
    </div>
  );
};

// Reusable Section Component
const Section = ({ title, content }) => {
  return (
    <div className="college-section">
      <h3 className="college-section-title">{title}</h3>
      <p className="college-section-content">{content}</p>
    </div>
  );
};

export default RCE;
